// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Emoji__emoji-b60cb6 {
  cursor: pointer;
  width: 46px;
  height: 46px;
  margin: 1px 0;
  font-size: 32px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  display: flex;
  transition: background-color 0.3s ease;
}

.Emoji__emoji-b60cb6:hover {
  background-color: var(--base-20);
}

.Emoji__emoji-b60cb6:active {
  background-color: var(--base-30);
}

@supports (display: block) {
  .Emoji__emoji-b60cb6:focus-visible {
    background-color: var(--base-20);
  }
}
.Emoji__emoji-b60cb6:last-child {
  margin-inline-end: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputSection/EmojisStickersButton/EmojiStickersPanel/EmojiPanel/EmojiList/Emoji/Emoji.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE;IACE,gCAAA;EACF;AACF;AAEA;EACE,uBAAA;AAAF","sourcesContent":[".emoji {\n  cursor: pointer;\n  width: 46px;\n  height: 46px;\n  margin: 1px 0;\n  font-size: 32px;\n  border-radius: 50%;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  transition: background-color 0.3s ease;\n}\n\n.emoji:hover {\n  background-color: var(--base-20);\n}\n\n.emoji:active {\n  background-color: var(--base-30);\n}\n\n@supports (display: block) {\n  .emoji:focus-visible {\n    background-color: var(--base-20);\n  }\n}\n\n.emoji:last-child {\n  margin-inline-end: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emoji": `Emoji__emoji-b60cb6`
};
module.exports = ___CSS_LOADER_EXPORT___;
